import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapEatAndPlayMenu, mapEatAndPlayMenuResponse } from "src/utils/mapEatAndPlay";

export const EAT_AND_PLAY_CASH_MENU_KEY = "cashMenu";
export const EAT_AND_PLAY_CASH_BREAKFAST_KEY = "cashBreakfast";
export const EAT_AND_PLAY_TOURNAMENT_MENU_KEY = "tournamentMenu";
export const EAT_AND_PLAY_TOURNAMENT_BREAKFAST_KEY = "tournamentBreakfast";
export const EAT_AND_PLAY_PAYLOAD_KEYS = [
  EAT_AND_PLAY_CASH_MENU_KEY,
  EAT_AND_PLAY_CASH_BREAKFAST_KEY,
  EAT_AND_PLAY_TOURNAMENT_MENU_KEY,
  EAT_AND_PLAY_TOURNAMENT_BREAKFAST_KEY,
];

/**
 * Fetches one Eat & Play menu from pg-payload-cms (`eat-and-play-menus`).
 * Enabled when `eat-and-play` is listed in `REACT_APP_PAYLOAD_SOURCES`.
 *
 * @param {string} locale - `en` | `fr`
 * @param {string} [key]
 * @returns {Promise<import('src/utils/mapEatAndPlay').EatAndPlayMenu | null>}
 */
export async function fetchEatAndPlayMenu(locale, key = EAT_AND_PLAY_CASH_MENU_KEY) {
  const url = buildPayloadApiUrl("/api/eat-and-play-menus", {
    locale,
    limit: 1,
    depth: 0,
    "where[key][equals]": key,
  });

  const response = await payloadFetch(url);
  return mapEatAndPlayMenuResponse(response, locale);
}

/**
 * Fetches a single menu by id (Live Preview / drafts).
 *
 * @param {string|number} id
 * @param {string} locale
 * @returns {Promise<import('src/utils/mapEatAndPlay').EatAndPlayMenu | null>}
 */
export async function fetchEatAndPlayMenuById(id, locale) {
  const url = buildPayloadApiUrl(`/api/eat-and-play-menus/${id}`, {
    locale,
    depth: 0,
    draft: true,
  });
  const doc = await payloadFetch(url);
  return mapEatAndPlayMenu(doc, locale);
}
